import MsgDatePicker from "./MsgDatePicker";

const CustomComponents = {
  install: function (Vue) {
    Vue.component('MsgDatePicker', MsgDatePicker);
  }
};

export default CustomComponents;



// WEBPACK FOOTER //
// ./src/components/customComponents/index.js